<template>
<div class="StepTwo">
    <div class="page-module">
        <ul>
            <div v-for="(item, index) in cardList" :key="index">
                <li class="animated fadeInUp">
                    <div :class="{'card': true, 'active': activeCard == item.code}" @click="activeCard = item.code">
                        <div class="head">
                            <p>{{item.name}}</p>
                            <p>{{item.english}}</p>
                        </div>
                        <div class="msg">
                            <p>{{item.desp}}</p>
                        </div>
                    </div>
                </li>
                <div v-if="index == 2" class="clear"></div>
            </div>
        </ul>
    </div>
    <div class="page-module btnlist animated fadeInUp">
        <el-button @click="upStep" type="primary" plain>上一步</el-button>
        <el-button @click="nextStep" type="primary">下一步</el-button>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'StepTwo',
    data() {
        return {
            cardList: [
                // {innerid: '1', title: '市盈率模型', twoLeverTitle: 'Price-earnings ratio valuation method', msg: '适用于周期性较弱的企业、一般制造业、服务业；不适用亏损公司、周期性公司。'},
                // {innerid: '2', title: '市净率估值法', twoLeverTitle: 'Price-to-book ratio valuation method', msg: '适用于周期性公司、重组公司；不适用重置成本较大的公司、固定资产较少的服务行业。'},
                // {innerid: '3', title: '现金流折现法', twoLeverTitle: 'Discounted cashflow model', msg: '适用于周期性较弱的企业、一般制造业、服务业；不适用亏损公司、周期性公司。'},
                // {innerid: '4', title: '基于运营数据估值模型', twoLeverTitle: 'Operational data valuation model', msg: '在互联网商业项目走过了早期后，一些运营数据可能更准确地支撑投资者对于项目价值的判断。这个模型衡量出了一个互联网商业模式在整个生命周期内可以获取的GMV。'},
                // {innerid: '5', title: '博克斯模型', twoLeverTitle: 'Box model', msg: '适用于初创期的企业进行价值评估：该方法好处是将初创企业的价值与各种无形资产的联系清楚的展现出来，比较简单易行，通过这种方法得出的企业价值一般比较合理。'},
                // {innerid: '6', title: '上市逆推法', twoLeverTitle: 'Reverse listing method', msg: '适用于企业发展稳定、状况良好、预计未来几年上市的发展期企业。'}
            ],
            activeCard: ''
        }
    },
    mounted() {
        $('html').scrollTop(0)
    },
    methods: {
        getCardData(data) {
            this.cardList = data
        },
        // 上一步
        upStep() {
            this.$emit('setStepValue', 0)
        },
        // 下一步
        nextStep() {
            // console.log(this.activeCard)
            if (this.activeCard === '') {
                this.$message.warning('请选择估值方法')
            } else {
                this.$emit('setTypeValue', this.activeCard)
                this.$emit('setStepValue', 2)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" scoped>
.StepTwo {
    ul {
        min-height: 320px;
        margin-left: -40px;
        padding: 10px 0;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
    }
    .clear {
        clear: both;
    }
     ul  li {
            float: left;
            position: relative;
            margin-left: 40px;
            margin-bottom: 56px;
            width: 360px;
            height: 310px;
            .card {
                position: relative;
                left: 0;
                top: 0;
                width: 360px;
                height: 310px;
                background:rgba(255,255,255,1);
                box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -webkit-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -moz-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -ms-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                -o-box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
                cursor: pointer;
                border-radius: 7px;
                transition: all .5s;
                -webkit-transition: all .5s;
                -ms-transition: all .5s;
                -o-transition: all .5s;
                -moz-transition: all .5s;
                border: solid 1px rgba(0,0,0,0.15);

                &:hover,
                &.active {
                    position: absolute;
                    left: -5px;
                    top: -5px;
                    width: 370px;
                    height: 320px;
                    border: solid 1px #409EFF;
                    &,
                    .title {
                        transition: all .5s;
                        -webkit-transition: all .5s;
                        -ms-transition: all .5s;
                        -o-transition: all .5s;
                        -moz-transition: all .5s;
                    }
                    
                    .title {
                        color: #409EFF;
                    }
                }

                &.active::before {
                    content: '';
                    opacity: 1;
                }
                &::before {
                    content: '';
                    position: absolute;
                    z-index: 1;
                    display: block;
                    right: 20px;
                    top: 20px;
                    width: 30px;
                    height: 30px;
                    background-image: url('../../../../common/images/gujing/gz/icon-step-radio2.png');
                    background-size: 30px 30px;
                    background-repeat: no-repeat;
                    background-position: center;
                    transition: all .5s;
                    -webkit-transition: all .5s;
                    -ms-transition: all .5s;
                    -o-transition: all .5s;
                    -moz-transition: all .5s;
                    opacity: 0;
                }
               
                .head {
                    position: relative;
                    // padding: 20px;
                    margin-top: 70px;
                    box-sizing: border-box;
                    // height:120px;
                    text-align: center;
                 
                    p {
                        font-size: 22px;
                        &~p {
                            margin-top: 12px;
                            color: #999999;
                            font-size: 18px;
                        }
                    }
                }
                .msg {
                    margin: auto;
                    margin-top: 30px;
                    width: 320px;
                    line-height: 20px;
                }
            }
        }
}
</style>